import { TimeString } from '../misc/TimeString';

angular.module("tromanWeb").directive("ergoPersonalnumber", [function () {

    function checkPersonalNumber(pn) {
        if (pn.length !== 10) return false;

        var ii, digit;
        var sum = 0;

        for (ii = 0; ii < 9; ++ii) {
            digit = parseInt(pn[ii], 10);
            if (isNaN(digit) || digit < 0 || digit > 9) return false;

            digit = digit * (2 - ii % 2);
            sum += (digit < 10 ? digit : digit - 9);
        }

        return parseInt(pn[9]) === ((10 - sum % 10) % 10);
    }

    var pnre = /^([0-9]{8})(?:-?([0-9]{4}))?$/;

    function isValidAsPersonalNumber(value) {
        if (typeof (value) !== 'string') return false;

        var match = pnre.exec(value.trim());
        if (!match) return false;
        if (!match[2]) return true;

        return checkPersonalNumber(match[1].substring(2) + match[2]);
    }

    return {
        restrict: "A",
        require: '?ngModel',
        link: function (_scope, _element, _attributes, ctrl) {
            if (!ctrl) return;

            // TODO: Should this use viewValue?
            ctrl.$validators.personalnumber = function (_modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isValidAsPersonalNumber(viewValue);
            };
        }
    };
}]);

angular.module("tromanWeb").directive("ergoZipcode", [function () {

    var zre = /^(?:(\d\d\d) ?(\d\d)|([A-Za-z].*))$/;

    function isValidAsZipcode(value) {
        if (typeof (value) !== 'string') return false;
        return zre.test(value);
    }

    return {
        restrict: "A",
        require: '?ngModel',
        link: function (_scope, _element, _attributes, ctrl) {
            if (!ctrl) return;

            // TODO: Should this use viewValue?
            ctrl.$validators.zipcode = function (_modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isValidAsZipcode(viewValue);
            };
        }
    };
}]);


angular.module("tromanWeb").directive("ergoTimespan", [function () {
    
    return {
        restrict: "A",
        require: '?ngModel',
        link: function (scope, element, attributes, ctrl) {
            if (!ctrl) return;
            
            element.on('blur', function () {
                // Use $applyAsync as the event might be fired synchronously
                // see ng-blur directive.
                scope.$applyAsync(function () {
                    let ts = TimeString.parse(ctrl.$viewValue);
                    if (ts != null && ctrl.$viewValue !== ts.str) {
                        ctrl.$setViewValue(ts.str);
                        ctrl.$render();
                    }
                });
            });

            if (attributes.ergoTimespan !== 'allowopen') {
                ctrl.$validators.timespan = function (value) {
                    var ts = TimeString.parse(value);
                    if (ts == null)
                        return false;
                    return ts.isClosed;
                };
            }
            
            ctrl.$parsers.push(value => {
                var ts = TimeString.parse(value);
                if (ts == null) {
                    return undefined;
                }
                return ts.str;
            });
        }
    };
}]);

angular.module("tromanWeb").directive("ergoTimespanWithin", [function () {

    const emptyTarget = TimeString.parse('');

    return {
        restrict: "A",
        require: '?ngModel',
        link: function (scope, _element, attributes, ctrl) {
            if (!ctrl) return;

            /**@type {TimeString} */
            let target = emptyTarget;
            scope.$watch(attributes.ergoTimespanWithin, function (val) {
                if (typeof val === 'string') {
                    target = TimeString.parse(val);
                } else {
                    target = emptyTarget;
                }
                
                ctrl.$validate();
            });

            ctrl.$validators.timewithin = value => {
                let ts = TimeString.parse(value);
                return target.contains(ts);
            };
        }
    };
}]);

angular.module("tromanWeb").directive("ergoDivides", [function () {

    return {
        restrict: "A",
        require: '?ngModel',
        link: function (scope, _element, attributes, ctrl) {
            if (!ctrl) return;
            if (!attributes.ergoDivides) return;

            var numerator = 0;

            scope.$watch(attributes.ergoDivides, function (val) {
                if (typeof val === 'number' && !isNaN(val)) {
                    numerator = val;
                } else {
                    numerator = 0;
                }
                ctrl.$validate();
            });

            ctrl.$validators.divides = function checkDivides(value) {
                if (ctrl.$isEmpty(value))
                    return true;
                if (typeof value !== 'number')
                    return false;
                if (isNaN(value))
                    return false;

                var mod = numerator % value;
                return mod === 0;
            };            
        }
    };
}]);

angular.module('tromanWeb').directive('ergoFormError', [function () {
    return {
        restrict: 'A',
        require: '?^form',
        link: function (scope, element, attributes, formController) {
            if (!formController) return;

            var match = /(\w+)\s+on\s+(.*)/.exec(attributes.ergoFormError);
            if (!match) return;

            var key = match[1];
            var expr = match[2];

            function setError(val) {
                element.toggleClass('has-error', val);
                formController.$setValidity(key, !val, formController);
            }

            scope.$watch(expr, setError);
            scope.$on('$destroy', function () {
                setError(false);
            });
        }
    };
}]);
